import AdvancedCreateModal from 'components/CIMSModal/AdvancedCreateModal'
import { useGlobalState } from 'context/GlobalStateContext'
import { useConcreteMixDesignsContext } from '../../MixDesignsContext'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useCreateConcreteMixDesignMutation } from 'schema'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { Row } from 'antd'
import { AggregateFields, OptionalFields, RequiredFields } from '../Fields'
import { FieldValues } from '../Fields/types'
import CustomFieldEditor from 'components/CustomFields/CustomFieldEditor'
import { errorHandler } from 'hooks/errorHandler'

const CreateModal: React.FC = () => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const {
    refetch,
    create: { visible, toggle },
  } = useConcreteMixDesignsContext()
  const [create] = useCreateConcreteMixDesignMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createConcreteMixDesign: {
        mixDesign: { mixDesignNumber, globalId },
      },
    }) => simpleCreateNotification(mixDesignNumber ?? globalId),
  })
  const { toMutateCustomFieldsInput } = useProjectCustomFieldsContext()

  return (
    <AdvancedCreateModal
      initialFormValues={{
        aggregates: ['', ''],
      }}
      visible={visible}
      onClose={() => toggle(null)}
      details={
        <Row gutter={30}>
          <RequiredFields />
          <AggregateFields />
        </Row>
      }
      additionalInfo={
        <>
          <Row gutter={30}>
            <OptionalFields />
          </Row>
          <CustomFieldEditor alreadyDisabled={false} hideBooleans={false} />
        </>
      }
      attachments={false}
      ok={{
        fn: async (store) => {
          if (!projectId) return errorHandler('Project id must be defined')

          const {
            slump,
            air,
            customFields,
            admixtures,
            class: classType,
            expirationDate,
            materialSource,
            maxAggSize,
            mixDesignNumber,
            wc,
            ...input
          } = store as FieldValues

          await create({
            variables: {
              input: {
                ...input,
                projectId,
                // Required field so using bang
                wc: wc!,
                // Required field so using bang
                mixDesignNumber: mixDesignNumber!,
                // Required field so using bang
                maxAggSize: maxAggSize!,
                // Required field so using bang
                materialSource: materialSource!,
                // Required field so using bang
                expirationDate: expirationDate!.toISOString(),
                // Required field so using bang
                class: classType!,
                // Required field so using bang
                admixtures: admixtures!,
                // Required field so using bang
                slumpLowInches: slump!.min!,
                // Required field so using bang
                slumpHighInches: slump!.max!,
                // Required field so using bang
                airLow: air!.min!,
                // Required field so using bang
                airHigh: air!.max!,
                customFields: toMutateCustomFieldsInput(customFields),
              },
            },
          })
          refetch()
        },
      }}
    />
  )
}

export default CreateModal
